import { useEffect, useState } from "react";
import { Warehouse, Loader2, Search } from "lucide-react";
import { api } from "../../lib/api";

// Inventario por tienda: matriz SKU × tienda con existencias reales.
export default function RetailStockByStore() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/retail/inventory/by-store").then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="py-16 flex justify-center text-navy/40"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  const stores = data?.stores || [];
  const rows = (data?.rows || []).filter((r) => !q.trim() || `${r.sku} ${r.descripcion}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="retail-stock-map">
      <div className="relative mb-4 max-w-sm">
        <Search className="w-4 h-4 text-navy/40 absolute left-3 top-1/2 -translate-y-1/2" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar SKU o producto…" className="w-full field pl-10" data-testid="stock-search" />
      </div>
      {rows.length === 0 ? (
        <div className="card-surface p-8 text-center text-sm text-navy/40">Sin existencias por tienda. El inventario se puebla al recibir compras en <b>CEDIS</b> o registrar existencias por ubicación.</div>
      ) : (
        <div className="card-surface overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-navy/10 text-[11px] text-navy/40 uppercase tracking-wider">
                <th className="text-left px-4 py-2.5 sticky left-0 bg-white">SKU / Producto</th>
                {stores.map((s) => <th key={s} className="text-right px-3 py-2.5 whitespace-nowrap">{s}</th>)}
                <th className="text-right px-4 py-2.5">Total</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.sku} className="border-b border-navy/5 last:border-0" data-testid={`stock-row-${r.sku}`}>
                  <td className="px-4 py-2.5 sticky left-0 bg-white"><div className="truncate max-w-[220px]">{r.descripcion}</div><div className="text-[11px] text-navy/40">{r.sku}</div></td>
                  {stores.map((s) => <td key={s} className={`text-right px-3 py-2.5 ${r.por_tienda[s] > 0 ? "" : "text-navy/25"}`}>{r.por_tienda[s] || 0}</td>)}
                  <td className="text-right px-4 py-2.5 font-medium">{r.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
